import Base from '../Base';
import Swiper from 'swiper';

export class HomePage extends Base {
    init(id, main, locale) {
        console.log(':: Old HomePage ::');

        // Swiper for publications
        var bannersSwiper = new Swiper('.swiper-banners', {
            breakpoints: {
                // when window width is >= 769px
                769: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
                // when window width is >= 641px
                641: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
            },
            pagination: {
                clickable: true,
                el: '.swiper-pagination',
            },
            slidesPerView: 1,
            watchOverflow: true,
        });
    }
}

export default class NewHomePage extends Base {
    init(id, main, locale) {
        console.log(':: HomePage ::');

        const sliderObject = document.querySelector('#otherProjects_slider');
        let orderCount, startAt;

        if (sliderObject) {
            const order_object = sliderObject.dataset.order;
            orderCount = document.getElementById('wrapperOtherProjects').childElementCount;
            startAt = order_object - 1;

            if (startAt == 0) {
                startAt = orderCount - 1;
            } else {
                startAt -= 1;
            }
        }

        // Declare Swiper instance
        let swiper;

        const initializeSwiper = () => {
            if (swiper) {
                swiper.destroy(true, true); // Destroy the previous instance
            }

            swiper = new Swiper('.otherProjects-container', {
                slidesPerView: 1,
                spaceBetween: 40,
                allowTouchMove: true,
                preventClicks: false,
                preventClicksPropagation: false,
                watchSlidesVisibility: true,
                initialSlide: 0,
                updateOnWindowResize: true,

                breakpoints: {
                    1100: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                        allowTouchMove: false,
                        initialSlide: 0,
                        preventClicks: false,
                        preventClicksPropagation: false,
                        simulateTouch: false,
                    },
                    992: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                        allowTouchMove: false,
                        initialSlide: 0,
                        preventClicks: false,
                        preventClicksPropagation: false,
                        simulateTouch: false,
                    },
                },
            });

            const prevButton = document.querySelector('.otherProjects-prev');
            const nextButton = document.querySelector('.otherProjects-next');

            const updateButtonClasses = () => {
                if (swiper.isBeginning) {
                    prevButton.classList.add('disabled');
                } else {
                    prevButton.classList.remove('disabled');
                }

                if (swiper.isEnd) {
                    nextButton.classList.add('disabled');
                } else {
                    nextButton.classList.remove('disabled');
                }
            };

            updateButtonClasses();

            swiper.on('slideChange', updateButtonClasses);
            swiper.on('reachBeginning', updateButtonClasses);
            swiper.on('reachEnd', updateButtonClasses);

            if (nextButton) {
                nextButton.addEventListener('click', () => {
                    swiper.slideNext();
                });
            }

            if (prevButton) {
                prevButton.addEventListener('click', () => {
                    swiper.slidePrev();
                });
            }
        };

        // Initialize Swiper for the first time
        initializeSwiper();

        // Reinitialize Swiper on window resize
        window.addEventListener('resize', initializeSwiper);

        window.onload = function () {
            jQuery('.otherProjects-container .swiper-wrapper').each(function () {
                let highestBox = 0;
                jQuery('.swiper-slide', this).each(function () {
                    if (jQuery(this).height() > highestBox) {
                        highestBox = jQuery(this).height();
                    }
                });

                jQuery('.swiper-slide', this).height(highestBox);
            });
        };
    }
}
